module.exports = __webpack_public_path__ + "img/reset-password-v2.27b3ac8a.svg";